import { FC, useCallback, useState } from "react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";

import { DownloadIcon } from "../../../icons";

export interface UsageDownloadCsvProps {
  /** Performs the download. The button shows its spinner until the returned promise settles. */
  onDownload: () => Promise<unknown>;
  disabled?: boolean;
}

const UsageDownloadCsv: FC<UsageDownloadCsvProps> = ({
  onDownload,
  disabled = false,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);
  const isDisabled = disabled || isDownloading;

  const handleDownload = useCallback(async () => {
    if (isDisabled) return;

    setIsDownloading(true);
    try {
      await onDownload();
    } finally {
      setIsDownloading(false);
    }
  }, [isDisabled, onDownload]);

  return (
    <Tooltip title="Download CSV" arrow>
      <span>
        <IconButton
          size="small"
          aria-label="Download CSV"
          onClick={handleDownload}
          disabled={isDisabled}
          sx={{
            opacity: isDisabled ? 0.5 : 1,
          }}
        >
          {isDownloading ? (
            <CircularProgress size={20} aria-label="Downloading CSV" />
          ) : (
            <DownloadIcon size={20} />
          )}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default UsageDownloadCsv;
